/**
 * Created by nijin.a on 2/19/2018.
 */

const PAGE_TITLE = {
  ON_BOARD: 'Onboard thing',
  THING_LIST: 'Things',
  THING_DETAILS: 'Thing Details',
  SCHEMA: 'Schemas',
  TEMPLATE: 'Templates',
  TEAM: 'Team',
  PROFILE: 'Profile',
  PASSWORD: 'Change password',
  WHY_NUC: 'Why Nucleus',
  ARE_YOU: 'What are you looking for',
  PRICING: 'Plan and pricing',
  USE_CASE: 'Use cases',
  DEFAULT: 'Nucleus - Powered by CantizAI',
  API_KEY: 'API Key',
  PLATFORM: 'Platform',
  NUCLEUS: 'Nucleus',
  NEUTRON: 'Neutron',
  ELECTRON: 'Electron',
  DOWNLOADS: 'Downloads',
  REGISTER: 'Register',
  INVITE: 'Invite',
  CREATE_SCHEMA: 'Create Schema'
};

export const GLOBAL_CONSTANTS = {
  PAGE_TITLE
};





// WEBPACK FOOTER //
// ./src/app/global/global.constants.ts